import React, { useState, useEffect } from "react";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
// estilos rápidos customizados para o calendário (injetados aqui por simplicidade)
const calendarCustomStyles = `
.react-calendar { border: none; font-family: Arial, Helvetica, sans-serif; width: 100%; }
.react-calendar__navigation button { color: #005c53; font-weight: 600; }
.react-calendar__navigation { height: 48px; }
.react-calendar__tile--now.notify-today, .react-calendar__tile.notify-today { background: #005c53; color: #fff; border-radius: 8px; }
.react-calendar__tile { border-radius: 6px; padding: 12px 6px; }
.react-calendar__month-view__weekdays__weekday { color: #005c53; font-weight: 600; }

/* remove outline on buttons but keep accessibility focus styles */
.react-calendar button:focus { outline: 2px solid rgba(0,92,83,0.12); }

/* Mobile adjustments */
@media (max-width: 768px) {
  .react-calendar { box-shadow: none; }
  .react-calendar__navigation { height: 56px; display: flex; align-items: center; }
  .react-calendar__navigation button { font-size: 16px; padding: 8px 10px; }
  .react-calendar__tile { padding: 16px 6px; font-size: 14px; }
  .react-calendar__month-view__days__day { min-height: 56px; }
  .react-calendar__tile--now.notify-today, .react-calendar__tile.notify-today { border-radius: 10px; padding: 14px 6px; }
  .react-calendar__tile--active { background: #00473f !important; color: #fff !important; }
}
`;
const styleEl = document.createElement('style');
styleEl.appendChild(document.createTextNode(calendarCustomStyles));
document.head.appendChild(styleEl);
import LogoCompleta from "../../../assets/logonotify1.png";
import LogoIcone from "../../../assets/notifyicone.png";



const HEADER_HEIGHT = 56;

const Calendario = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [date, setDate] = useState(new Date());
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const generateSampleEvents = (d) => {
    // Gera alguns eventos de exemplo baseados na data (substituir por API real)
    const day = new Date(d).getDate();
    const events = [];
    const count = (day % 5) + 1; // 1 a 5 eventos
    for (let i = 0; i < count; i++) {
      const hour = 9 + (i * 2) % 8;
      events.push({
        id: `${d.toDateString()}-${i}`,
        time: `${String(hour).padStart(2, '0')}:00`,
        title: `Agendamento ${i + 1}`,
        description: `Descrição do agendamento ${i + 1} para ${d.toLocaleDateString()}`,
      });
    }
    return events;
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar Bootstrap 5 */}
      <nav
        className={`d-flex flex-column flex-shrink-0 text-white${window.innerWidth <= 768 && sidebarOpen ? ' menu-aberto' : ''}`}
        style={{
          width:
            window.innerWidth <= 768
              ? sidebarOpen
                ? "80vw"
                : 56
              : sidebarOpen
              ? 220
              : 70,
          maxWidth:
            window.innerWidth <= 768
              ? sidebarOpen
                ? 260
                : 56
              : sidebarOpen
              ? 220
              : 70,
          minWidth:
            window.innerWidth <= 768
              ? 56
              : sidebarOpen
              ? 220
              : 70,
          background: "#005c53",
          minHeight: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          zIndex: window.innerWidth <= 768 && sidebarOpen ? 3000 : 1300,
          transition: "width 0.3s",
          alignItems: "center",
          boxShadow:
            window.innerWidth <= 768 && sidebarOpen
              ? "4px 0 16px rgba(0,0,0,0.18)"
              : "2px 0 8px rgba(0,0,0,0.10)",
          overflowX: "hidden",
          overflowY: "auto",
          scrollbarWidth: "thin",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: sidebarOpen ? "row" : "column",
            justifyContent: sidebarOpen ? "space-between" : "center",
            alignItems: "center",
            padding: sidebarOpen ? "16px 16px 8px 16px" : "24px 0 8px 0",
            transition: "all 0.3s",
            gap: sidebarOpen ? 12 : 8,
          }}
        >
          {sidebarOpen ? (
            <a href="/app">
              <img src={LogoCompleta} alt="Logo Completa" style={{ height: 40, transition: "all 0.3s" }} />
            </a>
          ) : (
            <a href="/app">
              <img src={LogoIcone} alt="Logo Ícone" style={{ height: 32, width: 32, transition: "all 0.3s" }} />
            </a>
          )}
          <button
            onClick={() => setSidebarOpen((open) => !open)}
            className="btn btn-link text-white"
            style={{
              fontSize: 24,
              textDecoration: "none",
              boxShadow: "none",
              marginLeft: sidebarOpen ? 12 : 0,
              marginRight: 0,
              padding: 0,
              alignSelf: "center",
            }}
            title={sidebarOpen ? "Fechar menu" : "Abrir menu"}
          >
            <i className={`bi ${sidebarOpen ? "bi-x-lg" : "bi-list"}`}></i>
          </button>
        </div>
        <ul className="nav nav-pills flex-column mb-auto w-100"
          style={{
            alignItems: sidebarOpen ? "flex-start" : "center",
            gap: sidebarOpen ? 0 : -12,
            paddingBottom: 0,
          }}>
          <li className="nav-item w-100">
            <a
              href="/app"
              className="nav-link d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
                background: "#51a197",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: 8,
                transition: "background 0.3s",
              }}
            >
              <i className="bi bi-speedometer2" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12, color: "#fff" }}>Dashboard</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Campanha" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-megaphone" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Campanhas</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Projetos" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi-robot" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Automações</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Adicionarauto" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-person-lines-fill" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Contas</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Operacoes" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-gear" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Operações</span>}
            </a>
          </li>


         <li className="w-100">
            <a
              href="/Blacklist"
              className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}
            >
              <i className="bi-person-x" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Blacklist</span>}
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} />
          </li>


           <li className="w-100">
            <a
              href="/Webhook"
              className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}
            >
              <i className="bi-link-45deg" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Webhook</span>}
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} />
          </li>

       <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="#" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-wifi" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Broadcasts</span>}
            </a>
          </li>
          
        </ul>
      </nav>
      {/* Header fixo no topo, mas atrás do menu lateral */}
      <nav
        className="navbar navbar-expand-lg navbar-dark"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: HEADER_HEIGHT,
          background: "#005c53",
          zIndex: 1200,
          borderRadius: 0,
          marginLeft: 0,
        }}
      >
        <div style={{ marginLeft: sidebarOpen ? 220 : 70, transition: "margin-left 0.3s" }}>
          <span style={{ color: "#fff", fontWeight: "bold", fontSize: 20 }}>Calendário</span>
        </div>
        <div className="ms-auto d-flex align-items-center pe-3">
          <div className="dropdown">
            <a
              href="#"
              className="nav-link d-flex align-items-center p-0"
              id="userDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ color: "#fff", cursor: "pointer" }}
            >
              <i
                className="bi bi-person-circle"
                style={{
                  fontSize: 28,
                }}
              ></i>
              <span
                className="d-none d-lg-inline ms-2"
                style={{
                  padding: "6px 16px",
                  borderRadius: 16,
                  transition: "background 0.2s",
                  display: "inline-block",
                }}
              >
                Nome do Usuário
              </span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
               <li>
                <a className="dropdown-item" href="/Editarperfil">Perfil</a>
              </li>

              <li>
                <a className="dropdown-item" href="#">Treinamentos</a>
              </li>

              <li>
                <a className="dropdown-item" href="#">Termos de uso</a>
              </li>

              <li>
                <a className="dropdown-item" href="/sign-in">Sair</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Conteúdo da página de campanha */}
      <div style={{
        marginLeft: windowWidth > 768 ? (sidebarOpen ? 220 : 70) : 0,
        paddingTop: windowWidth > 768 ? HEADER_HEIGHT + 32 : HEADER_HEIGHT + 12,
        width: windowWidth > 768
          ? sidebarOpen
            ? "calc(100% - 220px)"
            : "calc(100% - 70px)"
          : "100vw",
        transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
        padding: 24,
      }}>
        <div style={{ maxWidth: 980, margin: '0 auto' }}>
          <h1 style={{ color: '#005c53', marginBottom: 12, marginLeft: windowWidth <= 768 ? 56 : 0 }}>Calendário</h1>
          <div style={{ background: '#fff', padding: 20, borderRadius: 12, boxShadow: '0 6px 20px rgba(0,0,0,0.08)' }}>
            <div style={{ display: 'flex', gap: 20, alignItems: 'flex-start', flexWrap: 'wrap', flexDirection: windowWidth <= 768 ? 'column' : 'row' }}>
              <div style={{ flex: '1 1 520px', minWidth: 300 }}>
                <div style={{ width: '100%', maxWidth: windowWidth <= 768 ? '100%' : 760 }}>
                  <Calendar
                    onChange={setDate}
                    value={date}
                    showNeighboringMonth={false}
                    nextLabel={<i className="bi bi-chevron-right" />}
                    prevLabel={<i className="bi bi-chevron-left" />}
                    next2Label={null}
                    prev2Label={null}
                    tileClassName={({ date: d, view }) => {
                      // destaque do dia atual
                      const today = new Date();
                      if (d.toDateString() === today.toDateString()) return 'notify-today';
                      // destaque data selecionada
                      if (d.toDateString() === new Date(date).toDateString()) return 'react-calendar__tile--active';
                      return null;
                    }}
                  />
                </div>
              </div>

              <div style={{ width: windowWidth <= 768 ? '100%' : 340, minWidth: 260, marginLeft: windowWidth <= 768 && !sidebarOpen ? 30 : (windowWidth > 768 && !sidebarOpen ? 20 : 0) }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <div style={{ fontWeight: 700, color: '#005c53' }}>{new Date(date).toLocaleDateString()}</div>
                  <div style={{ color: '#6b7280', fontSize: 13 }}>{generateSampleEvents(date).length} agendamentos</div>
                </div>
                <div style={{ border: '1px solid #eef2f4', borderRadius: 8, maxHeight: 420, overflowY: 'auto', padding: 8 }}>
                  {generateSampleEvents(date).map((ev) => (
                    <div key={ev.id} style={{ padding: 10, borderRadius: 8, marginBottom: 8, background: '#fbfdfe' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ fontWeight: 700, color: '#00473f' }}>{ev.title}</div>
                        <div style={{ color: '#005c53', fontWeight: 700 }}>{ev.time}</div>
                      </div>
                      <div style={{ marginTop: 6, color: '#6b7280', fontSize: 13 }}>{ev.description}</div>
                    </div>
                  ))}
                  {generateSampleEvents(date).length === 0 && (
                    <div style={{ color: '#6b7280', padding: 12 }}>Não há agendamentos para esta data.</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calendario;